import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  Col,
  Row,
  Modal,
  Container,
  Button,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { getHRFiles } from "../../api/api";
import OrgStructure from "./OrgStructure";
import FlipBookControlDemo from "./FlipBookControlDemo";

export const HRDivision = () => {
  const { i18n, t } = useTranslation();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const cardsData = [
    // {
    //   id: 1,
    //   tag: "Policy",
    //   title: t("hr_policy"),
    //   // link: `/HR/Policy`,
    //   imgSrc: "/hr/policy.png", // replace with actual path
    //   size: "xl",
    // },
    {
      id: 2,
      title: t("hr_organizational_structure"),
      imgSrc: "/hr/structure.png", // replace with actual path
      size: "xl",
    },
    {
      id: 3,
      tag: "Calendar",
      title: t("hr_annual_calendar"),
      imgSrc: "/hr/callender.png", // replace with actual path
      size: "lg",
    },
    {
      id: 4,
      //tag: "Announcements",
      link: "/HR/Announcements",
      title: t("hr_announcements"),
      imgSrc: "/hr/announcements.png", // replace with actual path
      size: "lg",
    },
    {
      id: 5,
      tag: "Manuals",
      title: t("hr_attendance_manuals"),
      imgSrc: "/hr/attendance.png", // replace with actual path
      size: "lg",
    },

    {
      id: 6,
      tag: "MedicalInsurance",
      title: t("hr_medical_insurance"),
      imgSrc: "/hr/medicalinsurance.png", // replace with actual path
      size: "lg",
    },

    {
      id: 7,
      link: "/HR/CommunicationWithHCDivision",
      title: t("hr_communicate_with_hc"),
      imgSrc: "/hr/contact.png", // replace with actual path
      size: "lg",
    },
  ];

  interface Card {
    id: number;
    tag?: string;
    link?: string;
    title: string;
    subtitle?: string;
    imgSrc: string;
    size?: string;
  }

  interface ProcessedFile {
    id: number;
    title: string;
    fileName: string;
    fileUrl: string;
  }

  // const [selectedCard, setSelectedCard] = useState({Card});
  const [selectedCard, setSelectedCard] = useState<Card | null>(null);
  const [processedFiles, setProcessedFiles] = useState<ProcessedFile[] | null>(
    null
  );
  // Handle the link click to show the modal and set the selected card
  const handleLinkClick = async (card: Card) => {
    // if (card.id == 1) {
    //   return true;
    // }
    setProcessedFiles(null);
    setLoading(true);

    setSelectedCard(card);

    setShow(true); // Open modal

    if (card.tag) {
      try {
        const hrFilesResponse = await getHRFiles({
          tag: card.tag || "",
          language: i18n.language,
        });
        setLoading(false);

        const hrFilesList = hrFilesResponse.data.map((item: any) => ({
          id: item.id,
          title: item.attributes.Title,
          fileName: item.attributes.file.data.attributes.name,
          fileUrl:
            process.env.REACT_APP_CMS +
            item.attributes.file.data.attributes.url,
        }));

        setProcessedFiles(hrFilesList);
        console.log("files", card.tag, hrFilesList);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setShow(false); // Open modal
      } finally {
        setLoading(false);
      }
    }
  };

  // Close the modal
  const handleClose = () => setShow(false);

  return (
    <>
      <Row className="g-4">
        {cardsData.map((card, index) => (
          <Col sm={12} md={6} lg={3} key={index}>
            <Link
              // target={card.id === 1 ? "_blank" : ""}
              to={card.link || "#"}
              onClick={() => handleLinkClick(card)} // Trigger modal on click
              style={{ display: "block" }}
            >
              <Card
                className="h-100 text-center"
                style={{ minHeight: "210px" }}
              >
                <Card.Img
                  variant="top"
                  src={card.imgSrc}
                  style={{ maxWidth: "80px", margin: "20px auto" }}
                />
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>
                  {/* <Card.Text>
                    {card.subtitle}
                  </Card.Text> */}
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      {/* Full Page Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        fullscreen="true"
        size={(selectedCard?.size as "lg" | "xl" | "sm") || "lg"}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedCard?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCard?.id === 2 || selectedCard?.id === 1 ? (
            <>
              {selectedCard?.id === 2 && <OrgStructure />}
              {selectedCard?.id === 1 && <FlipBookControlDemo />}
            </>
          ) : (
            <Container className="file-list mt-4">
              {loading && (
                <center>
                  <Spinner
                    animation="border"
                    role="status"
                    className="center-spinner"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </center>
              )}

              {processedFiles?.length === 0 && <center>{t("no_files")}</center>}

              {processedFiles?.map((file: ProcessedFile, index: number) => (
                <Row
                  key={index}
                  className="align-items-center file-item mb-3 py-2"
                >
                  <Col xs={8} className="file-name">
                    <i
                      className="bi bi-file-earmark-text"
                      style={{ marginRight: "10px", color: "#007bff" }}
                    ></i>{" "}
                    {file.title}
                  </Col>
                  <Col xs={4} className="text-end">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      href={file.fileUrl}
                    >
                      {t("donwload_file")}
                    </Button>
                  </Col>
                </Row>
              ))}
            </Container>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
